var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-footer"},[_c('span',[_vm._v("© Copyright 2015-"+_vm._s(_vm.currentYear)+" Pulse Health - All Rights Reserved")])])
}
var staticRenderFns = []

export { render, staticRenderFns }